import React from 'react';

import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import KycDocument, { DropzoneMeta } from '@/pages/settings/verify/kyc-sections/KycDocument';
import KycDescription from '@/pages/settings/verify/kyc-sections/KycDescription';
import { selectKycDocumentPOA } from '@/store/selectors/kycSelectors';
import { KycType } from '@lucky7ventures/bff-types';

const KycProofOfAddress = ({ maxFiles = 1 }: { maxFiles?: number }) => {
  const poaDocument = useSelector(selectKycDocumentPOA);
  const intl = useIntl();

  if (!poaDocument) {
    return null;
  }

  const dropzoneMeta: DropzoneMeta = {
    id: KycType.ProofOfAddress.toString(),
    minFiles: 1, // At least one file is needed for POA
    maxFiles,
    errorMessageTranslationKey: 'settings.verify.upload.error.imagesAndPdfOnly.text',
  };

  return (
    <KycDocument
      type={KycType.ProofOfAddress}
      status={poaDocument.status}
      acceptedFileTypes={['image/png', 'image/jpeg', 'application/pdf']}
      title={intl.formatMessage({ id: 'settings.verify.proofOfAddress.header' })}
      description={<KycDescription kycType={KycType.ProofOfAddress} />}
      dropzonesMeta={[dropzoneMeta]}
      validationErrorMessage={intl.formatMessage({
        id: 'settings.verify.submit.imagesAndPdfOnly.error',
      })}
      key={KycType.ProofOfAddress}
    />
  );
};

export default KycProofOfAddress;
